import React, { useEffect } from "react";

import AllRoute from "../src/main-component/router";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactGA from "react-ga4";
const App = () => {
  useEffect(() => {
    ReactGA.initialize("G-VFDGR8NY0G");
  }, []);


  return (
    <div id="scrool">
      <AllRoute />
      <ToastContainer />
    </div>
  );
};

export default App;
